<div class="p-4">
  <div class="d-flex justify-content-between">
    <div class="ticket-delete-modal__title">{{ 'cancel.process_l' | translate }}</div>
    <rs-web-icon
      [cursor]="'pointer'"
      [size]="20"
      [icon]="immomioIconName.Close"
      (tapped)="activeModal.dismiss()"
    ></rs-web-icon>
  </div>
  <div class="pt-4">{{ 'cancel.ticket.description.first.line_l' | translate }}</div>
  <div class="py-4">{{ 'cancel.ticket.description.second.line_l' | translate }}</div>
  <div class="d-flex gap-3">
    <button im-button class="inverted flex-grow-1" (click)="activeModal.dismiss()">
      {{ 'ticket_cancel_rejection_a' | translate }}
    </button>
    <button im-button class="negative flex-grow-1" (click)="activeModal.close()">
      {{ 'ticket.cancel_a' | translate }}
      <i iconEnd [class]="'icon-' + immomioIconName.Trash"></i>
    </button>
  </div>
</div>
